module.exports = "<div class=\"visual-divider\"></div>"